import {useSelector} from 'react-redux';

export default () =>
	useSelector(({dashboardContext}) => {
		const entities = dashboardContext.entities;
		if (entities.length === 0) return [];
		return entities.map(({entityId}) => entityId);
	});
